// React i hooks
import { memo, useState } from "react";

// API servisi
import { deleteTehnicalInspectionAPI } from "services/api/calculations/tehnicalinspection/api";


// Tipovi i konstante
import { TehnicalInspectionDeleteProps } from "./types";

// UI komponente
import { Button } from "ui/components/Button/Button";

import { Loader } from "ui/components/Loader";
import { ReactSVG } from "react-svg";
import { useTranslate } from "helpers";

const TehnicalInspectionDeleteCard: React.FC<
  TehnicalInspectionDeleteProps
> = (props) => {
  const { tehnicalInspectionId, onSuccess } = props;
  const { t } = useTranslate();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      let result;
      if (!!tehnicalInspectionId) {
        result = await deleteTehnicalInspectionAPI(
          tehnicalInspectionId
        );
      }

      if (result && onSuccess) onSuccess();
    } catch (e) {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
  };

  return (
    <>
      <div className="flex gap-4">
        <div className="w-full m-auto">
          <div className="space-y-3">
            <form noValidate className="text-left">
              <div className="px-5 pb-3 mb-2">
                <div className=" focus:outline-none focus:ring-2 focus:ring-slate-400 rounded-sm py-4 flex justify-center items-center mb-3">
                  <div className="flex items-center flex-col">
                    <ReactSVG
                      src={"/media/images/document-move.svg"}
                      className="mx-auto w-fit mb-10"
                    />
                    <div className="font-medium text-sm text-[#475467] ">
                      {t(
                        "admin.calculation.setting.tehnicalinspection.delete.description"
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-5 pb-5 flex justify-end ">
                <Button
                  variant="remove"
                  size="full"
                  children={t("admin.delete")}
                  onClick={handleFormSubmit}
                />
              </div>
            </form>
          </div>
        </div>
      </div>

      <Loader isLoading={isLoading ?? false}> </Loader>
    </>
  );
};
export default memo(TehnicalInspectionDeleteCard);
